module.exports = __webpack_public_path__ + "img/Lulumi.7fb9ef3c.jpg";